"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _colors = require("HubStyleTokens/colors");

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _color = require("MeetingsLib/utils/color");

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _hubspot = _interopRequireDefault(require("hubspot.SafeStorage"));

var _StyledSprocketIcon = _interopRequireDefault(require("MeetingsLib/components/freemium/StyledSprocketIcon"));

var _utils = require("MeetingsBase/utils/utils");

var _default = (0, _createReactClass.default)({
  displayName: "FreemiumUpgradeButton",
  propTypes: {
    handleButtonClick: _propTypes.default.func.isRequired,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      variation: 'control',
      treatmentFetched: false,
      experimentEnabled: false
    };
  },
  componentDidMount: function componentDidMount() {
    (0, _UsageTracker.track)('meetingsViralityPageView', {
      action: 'virality-thank-you-page-view'
    });
    var experimentIdentifier = this.generateRandomIdentifier('meetings-virality-experiment');
    this.setupExperiment(experimentIdentifier);
  },
  generateRandomIdentifier: function generateRandomIdentifier(param) {
    var storedExperimentIdentifier = param + "-exp-id";

    var random = _hubspot.default.getItem(storedExperimentIdentifier);

    if (!random) {
      random = Math.random();

      _hubspot.default.setItem(storedExperimentIdentifier, random);
    }

    return random;
  },
  setupExperiment: function setupExperiment(experimentIdentifier) {
    var _this = this;

    var experimentTimeout = setTimeout(this.handleTimeout, 1000); // 1 second to get the treatment, else we render the default.

    var postfix = (0, _utils.getEnvPostfix)();

    _noAuthApiClient.default.get("https://api.hubspot" + postfix + ".com/treatments/v1/get/acquisition-039/" + experimentIdentifier).then(function (treatment) {
      return _this.handleTreatmentFetched(treatment, experimentTimeout);
    }).catch(function () {
      _this.handleError();
    });
  },
  handleTreatmentFetched: function handleTreatmentFetched(treatment, experimentTimeout) {
    clearTimeout(experimentTimeout);

    if (treatment && treatment.parameters && treatment.parameters.length !== undefined) {
      var parameter = treatment.parameters[0]; // if the button has already rendered, don't change it

      if (!this.state.treatmentFetched) {
        this.setState({
          variation: parameter.value,
          treatmentFetched: true,
          experimentEnabled: parameter.isAssigned
        });
      }

      if (parameter.isAssigned) {
        (0, _UsageTracker.track)('meetingsLibViralityExperiment', {
          action: 'view',
          variation: this.state.variation
        });
      }
    } else {
      this.handleError();
    }
  },
  handleTimeout: function handleTimeout() {
    var treatmentFetched = this.state.treatmentFetched;

    if (!treatmentFetched) {
      this.setState({
        treatmentFetched: true
      });
      (0, _UsageTracker.track)('meetingsLibViralityExperiment', {
        action: 'error',
        variation: 'timeout'
      });
    }
  },
  handleError: function handleError() {
    (0, _UsageTracker.track)('meetingsLibViralityExperiment', {
      action: 'error',
      variation: 'error'
    });
    this.setState({
      treatmentFetched: true
    });
  },
  handleViralButtonClick: function handleViralButtonClick() {
    if (this.state.experimentEnabled) {
      (0, _UsageTracker.track)('meetingsLibViralityExperiment', {
        action: 'click',
        variation: this.state.variation
      });
    }

    this.props.handleButtonClick();
  },
  getBrandingActiveStyle: function getBrandingActiveStyle() {
    var primaryColor = this.props.branding.primaryColor;

    if (!primaryColor) {
      return null;
    }

    return {
      width: 'auto',
      borderColor: primaryColor,
      backgroundColor: (0, _color.getColorStyleWithOpacity)(primaryColor)
    };
  },
  getBrandingTextStyle: function getBrandingTextStyle() {
    var primaryColor = this.props.branding.primaryColor;

    if (!primaryColor) {
      return null;
    }

    return {
      color: primaryColor
    };
  },
  render: function render() {
    var handleButtonClick = this.props.handleButtonClick;
    var _this$state = this.state,
        variation = _this$state.variation,
        experimentEnabled = _this$state.experimentEnabled,
        treatmentFetched = _this$state.treatmentFetched;
    var isVariant = variation === 'variant' && experimentEnabled;
    return treatmentFetched ? isVariant ? _react.default.createElement(_UIButton.default, {
      className: "m-top-8",
      use: "primary",
      onClick: this.handleViralButtonClick
    }, _react.default.createElement(_StyledSprocketIcon.default, null), _react.default.createElement(_FormattedMessage.default, {
      message: "summary.meetingsAdvert.freemium"
    })) : _react.default.createElement(_UISelectableBox.default, {
      padded: false,
      selected: false,
      className: "freemium-advert-button",
      style: this.getBrandingActiveStyle(),
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: handleButtonClick
    }, _react.default.createElement(_UIIcon.default, {
      name: "sprocket",
      color: _colors.LORAX,
      className: "m-right-1"
    }), _react.default.createElement("span", {
      style: this.getBrandingTextStyle()
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "summary.meetingsAdvert.freemium"
    }))) : null;
  }
});

exports.default = _default;
module.exports = exports.default;